export function isValidNumber(num: any): boolean {
    return !isNaN(num) && Number.isFinite(num);
}
